import React from 'react';
import { arrayOf, shape, func, bool, number, string, node, oneOfType, } from 'prop-types';
import { Table } from '../../atoms';
import Pagination from '../../atoms/table/pagination';
import TableFilters from './table-filters';
import useTableData, { events } from './use-table-data';
import Observable from '../../common/observable';
const defaultSizePerPageOptions = [10, 25, 50, 100];
const TableWithFilters = ({ filters, fetcher, title, pagination, headerSlot, footerSlot, columns, getIsRowExpandable, ExpandedComponent, cache, observable, }) => {
    const { data, isLoading, controls } = useTableData({
        fetcher,
        pagination,
        filters,
        cache,
        observable,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(TableFilters, { filters: filters, controls: controls.customFilters }),
        React.createElement("div", { className: "b-twf__main" },
            (title || headerSlot) && (React.createElement("div", { className: "b-twf__header" },
                React.createElement("h3", { className: "b-twf__title" },
                    " ",
                    title,
                    " "),
                React.createElement("div", { className: "b-twf__header-slot" },
                    " ",
                    headerSlot,
                    " "))),
            React.createElement(Table, { columns: columns, getIsRowExpandable: getIsRowExpandable, ExpandedComponent: ExpandedComponent, data: data, setSort: controls.setSort, sort: controls.sort, isLoading: isLoading }),
            (footerSlot || pagination) && (React.createElement("div", { className: "b-twf__footer" },
                React.createElement("div", { className: "b-twf__footer-slot" },
                    " ",
                    footerSlot,
                    " "),
                pagination && (React.createElement(Pagination, { page: controls.page, setPage: controls.setPage, sizePerPage: controls.sizePerPage, setSizePerPage: controls.setSizePerPage, fixSizePerPage: pagination.fixSizePerPage, sizePerPageOptions: pagination.sizePerPage || defaultSizePerPageOptions, total: controls.total })))))));
};
TableWithFilters.propTypes = {
    title: string,
    filters: TableFilters.propTypes.filters,
    fetcher: func.isRequired,
    pagination: oneOfType([
        bool,
        shape({
            isLocal: bool,
            getTotal: func,
            transform: func,
            sizePerPage: number,
            sizePerPageOptions: arrayOf(number),
            fixSizePerPage: bool, // default - false
        }),
    ]),
    headerSlot: node,
    footerSlot: node,
    observable: shape({
        on: func,
        emit: func,
    }),
    cache: shape({
        invalidateTimeout: number.isRequired,
    }),
    columns: Table.type.propTypes.columns,
    getIsRowExpandable: Table.type.propTypes.getIsRowExpandable,
    ExpandedComponent: Table.type.propTypes.ExpandedComponent,
};
TableWithFilters.defaultProps = {
    title: undefined,
    pagination: undefined,
    headerSlot: undefined,
    footerSlot: undefined,
    filters: undefined,
    getIsRowExpandable: undefined,
    ExpandedComponent: undefined,
    columns: undefined,
    observable: undefined,
    cache: undefined,
};
TableWithFilters.Observable = Observable;
TableWithFilters.Filters = TableFilters;
TableWithFilters.events = events;
export default TableWithFilters;
